import { Controller } from "@hotwired/stimulus"

// Back arrow for the installed app (PWA), which has no browser back button.
// CSS shows it only in display-mode standalone. It goes back in history when
// there is a Veci page to return to, otherwise up to the breadcrumb's parent;
// with neither (e.g. the app's first screen) it stays hidden.
export default class extends Controller {
  connect() {
    this.element.hidden = !this.canGoBack && !this.parentPath
  }

  back() {
    if (this.canGoBack) {
      history.back()
    } else if (this.parentPath) {
      window.Turbo.visit(this.parentPath)
    }
  }

  // Turbo numbers its history entries; 0 is the first page of this visit.
  get canGoBack() {
    return (history.state?.turbo?.restorationIndex ?? 0) > 0
  }

  get parentPath() {
    const links = document.querySelectorAll(".page-breadcrumb a[href]")
    return links.length ? links[links.length - 1].getAttribute("href") : null
  }
}
